import Vue from 'vue'
import toast from './Toast.vue'

const ToastConstructor = Vue.extend(toast)
const toastPool = []
let instance

function showToast (toast) {
  toast.vm = toast.$mount()
  // document.body.append(toast.$el)
  var node = document.body.firstChild;
  if (node) {
    node.parentNode.insertBefore(toast.$el, node);
  } else {
    document.body.appendChild(toast.$el);
  }
  Vue.nextTick(() => {
    toast.visible = true
  })
}

function getInstance (options) {
  const def = {
    id: 'default',
    visible: false,
    duration: 3000,
    position: 'center',
    message: ''
  }
  const data = Object.assign(def, options)
  if (data['id'] && toastPool[data['id']]) {
    instance = toastPool[data['id']]
    instance.hide(true)
    instance = Object.assign(instance, data)
  } else {
    instance = new ToastConstructor({ data })
    toastPool[data['id']] = instance
  }

  showToast(instance)
  return instance
}

Vue.$toast = Vue.prototype.$toast = (message, config) => {
  if (typeof config === 'object') {
    return getInstance({ message, ...config })
  }
  return getInstance({ message })
}
